'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import RecomendadosPaginaDesktopFallback from './Designs/Desktop';
import RecomendadosPaginaMobileFallback from './Designs/Mobile';

export default function RecomendadosPaginaFallback() {
  const { breakpoint } = useBreakpoint();
  return breakpoint === 'mobile' ? (
    <RecomendadosPaginaMobileFallback />
  ) : (
    <RecomendadosPaginaDesktopFallback />
  );
}
